<div
  class="panel"
  [ngClass]="{
    'panel--static': toggleType === 'none',
    'panel--disabled': disabled,
    'panel--open': open,
    'panel--closed': open === false,
    'panel--compact': isCompact,
    'panel--no-padding': noPadding,
    'panel--inactive': !active
  }">
  <div class="panel__header" (click)="handleClickHeader()">
    <div class="panel__prefix"><ng-content select="[panel-prefix]"></ng-content></div>

    <div class="panel__label">
      <span class="html" [innerHTML]="label | markdown" *ngIf="label; else labelContent"></span>

      <ng-template #labelContent>
        <ng-content select="[panel-label]"></ng-content>
      </ng-template>
    </div>

    <div class="panel__actions" appEventFence>
      <ng-content select="[panel-actions]"></ng-content>
    </div>

    <ng-container [ngSwitch]="toggleType" *ngIf="toggleType !== 'none'">
      <!-- Arrow Toggle -->
      <div
        class="panel__toggle panel__toggle--arrow rotate--animate"
        [ngClass]="{
          'rotate-90': open,
          'rotate-0': !open
        }"
        *ngSwitchCase="'arrow'">
        <app-icon icon="angle-right"></app-icon>
      </div>

      <!-- Checkbox Toggle -->
      <div appEventFence class="panel__toggle panel__toggle--checkbox" *ngSwitchCase="'checkbox'">
        <mat-checkbox
          [disabled]="disabled"
          [checked]="open"
          (change)="open = $event.checked"></mat-checkbox>
      </div>
    </ng-container>
  </div>

  <!-- panel hint -->
  <div class="panel__hint text-11" *ngIf="hint && !open">
    {{ hint }}
  </div>

  <div class="panel__body">
    <ng-content></ng-content>
  </div>
</div>
